module.exports = __webpack_public_path__ + "static/fonts/HarmonyOS_Sans_SC_Regular.9705593a.woff2";